export const SEARCH_CUSTOMERS_BY_PARAMS = 'SEARCH_CUSTOMERS_BY_PARAMS';
export const SEARCH_CUSTOMERS_BY_PARAMS_FULFILLED = 'SEARCH_CUSTOMERS_BY_PARAMS_FULFILLED';
export const SEARCH_CUSTOMERS_BY_PARAMS_REJECTED = 'SEARCH_CUSTOMERS_BY_PARAMS_REJECTED';
